export const CSS = {
  actionGroupEnd: "action-group--end",
};

export const SLOTS = {
  actionsEnd: "actions-end",
  bottomActions: "bottom-actions",
  expandTooltip: "expand-tooltip",
};
